export default __webpack_public_path__ + "static/media/prenatalFrontBottle.e3ecbfc1.png";